const devToolsEnvironments = [
  'localhost',
  'medicare-frontend',
  'preprod',
  'compliance-staging',
  'review',
];

export const devtoolsEnvironmentCheck = () => {
  if (typeof window !== 'undefined') {
    const locationCheck = devToolsEnvironments.some((environment) =>
      window.location.origin.includes(environment)
    );
    return locationCheck;
  }
};
